import type { PocInputValidity } from 'commons/types';
import type { FieldCustomError } from 'core/types/field-errors.type';
import { getDateOrUndefined } from 'core/utils/dates';

export type TrainingRegistrationMappingDataAPI = {
    fileReferenceName: string;
    creationTime?: Date;
    mappings: TrainingRegistrationMappingAPI[];
    fallbacks: TrainingRegistrationMappingAPI[];
};

export type TrainingRegistrationMappingAPI = {
    pocField: string;
    lmsField: string;
    targetEntity: 'OPERATOR' | 'TRAINING';
};

export type TrainingRegistrationMappingData = {
    fileReferenceName: string;
    creationTime?: Date;
    mappings: TrainingRegistrationMapping[];
    fallbacks: TrainingRegistrationMapping[];
};

export type TrainingRegistrationMapping = {
    pocField: string;
    lmsField: string;
    targetEntity: 'OPERATOR' | 'TRAINING';
};

export type TrainingRegistrationMappingValidation = {
    pocField?: PocInputValidity;
    lmsField?: PocInputValidity;
};

export type TrainingRegistrationMappingCustomErrors = {
    pocField?: FieldCustomError[];
    lmsField?: FieldCustomError[];
};

export const defaultTrainingRegistrationMappingValidition: TrainingRegistrationMappingValidation = {
    pocField: undefined,
    lmsField: undefined,
};

export const defaultTrainingRegistrationMappingCustomErrors: TrainingRegistrationMappingCustomErrors = {
    pocField: undefined,
    lmsField: undefined,
};

export const newTrainingRegistrationMappingData = (): TrainingRegistrationMappingData => ({
    fileReferenceName: '',
    mappings: [],
    fallbacks: [],
});

export const mapTrainingRegistrationMappingDataFromAPIToModel = (
    trainingRegistrationsMappingData: TrainingRegistrationMappingDataAPI
): TrainingRegistrationMappingData => ({
    fileReferenceName: trainingRegistrationsMappingData.fileReferenceName,
    creationTime: getDateOrUndefined(trainingRegistrationsMappingData.creationTime),
    mappings: trainingRegistrationsMappingData.mappings.map(mapTrainingRegistrationMappingFromAPIToModel),
    fallbacks: trainingRegistrationsMappingData.fallbacks.map(mapTrainingRegistrationMappingFromAPIToModel),
});

export const mapTrainingRegistrationMappingFromAPIToModel = (
    trainingRegistrationsMapping: TrainingRegistrationMappingAPI
): TrainingRegistrationMapping => ({
    pocField: trainingRegistrationsMapping.pocField,
    lmsField: trainingRegistrationsMapping.lmsField,
    targetEntity: trainingRegistrationsMapping.targetEntity,
});
